<template>
	<router-link
		:to="this.fullPath"
		style="color: black">
		<div id="gameContainer">
			<v-avatar
				color="indigo"
				size="128">
				<v-img :src="this.logoPath" />
			</v-avatar>
			<p class="text-center text-h5">{{ this.name }}</p>
		</div>
	</router-link>
</template>

<script>
	import { ref } from 'vue';
	export default {
		setup(props) {
			const fullPath = ref(window.location.pathname + props.path);

			return {
				fullPath,
			};
		},
		props: {
			name: { type: String },
			logoPath: { type: String },
			path: { type: String },
		},
	};
</script>
